import React from 'react'

import { Stack } from '@mui/material'

import { Alert } from '@repo/ui'

import { useCompanyReferrals } from 'hooks/api/useInternalReferrals'

import { StaffReferralsTable } from '../../SignupsPage/referrals/StaffReferralsTable'
import { ReferralsSwitchedOffNotice } from 'components/feedback/ReferralsSwitchedOffNotice'

/**
 * VRG-658 — the referrals a company has SENT, on the internal company page.
 *
 * The SAME table the Signups → Referrals tab renders, scoped to this company
 * (working-conventions §71), with the "Referred by" column dropped because it would name
 * this company on every row. Row actions behave exactly as on the list.
 *
 * "Referred by" (who referred THIS company) is not here: it is a fact about the company, so
 * it sits with the other facts on the Details tab.
 */
export const CompanyReferralsPanel = ({ companyId }: { companyId: string }) => {
  const { data, isLoading, isError } = useCompanyReferrals(companyId)
  if (isError) return <Alert severity="error" title="We couldn't load this company's referrals." />
  return (
    <Stack spacing={4}>
      {/* VRG-680 — staff still see the referrals; this says why nothing new arrives. */}
      <ReferralsSwitchedOffNotice mb={0} />
      <StaffReferralsTable
        rows={data?.referrals_sent.data ?? []}
        loading={isLoading}
        scope="company"
        height={520}
        emptyTitle="No referrals sent"
        emptyText="When someone at this company refers a brand, it shows up here."
      />
    </Stack>
  )
}
